import { render } from "./CanvasZoomControls.vue?vue&type=template&id=56fded1a&scoped=true"
import script from "./CanvasZoomControls.vue?vue&type=script&lang=js"
export * from "./CanvasZoomControls.vue?vue&type=script&lang=js"

import "./CanvasZoomControls.vue?vue&type=style&index=0&id=56fded1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56fded1a"]])

export default __exports__